import React from 'react';

const upcomingShows = [
  {
    title: 'Τίτλος Παράστασης',
    venue: 'Χώρος Παράστασης, Αθήνα',
    dates: [
      { date: 'Παρ 14 Φεβρ 2025', time: '21:00', available: true },
      { date: 'Σαβ 15 Φεβρ 2025', time: '21:00', available: true },
      { date: 'Κυρ 16 Φεβρ 2025', time: '19:00', available: false },
      { date: 'Παρ 21 Φεβρ 2025', time: '21:00', available: true },
    ],
    price: '15€',
    reducedPrice: '10€',
  },
  {
    title: 'Άλλη Παράσταση',
    venue: 'Εναλλακτικός Χώρος, Πειραιάς',
    dates: [
      { date: 'Σαβ 1 Μαρτ 2025', time: '20:00', available: true },
      { date: 'Κυρ 2 Μαρτ 2025', time: '20:00', available: true },
    ],
    price: '12€',
    reducedPrice: '8€',
  },
];

export default function BoxOffice() {
  return (
    <section style={{ padding: '120px 64px', maxWidth: '1100px', margin: '0 auto' }}>
      <PageHeader title="Box Office" subtitle="Κρατήσεις & Εισιτήρια" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '56px' }}>
        {upcomingShows.map((show, i) => (
          <ShowTickets key={i} show={show} />
        ))}
      </div>
    </section>
  );
}

function ShowTickets({ show }) {
  const [selected, setSelected] = React.useState(null);

  return (
    <div style={{
      border: '1px solid var(--light-gray)',
      padding: '48px',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '40px',
        paddingBottom: '32px',
        borderBottom: '1px solid var(--light-gray)',
      }}>
        <div>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem',
            fontWeight: 400,
            color: 'var(--black)',
            letterSpacing: '0.04em',
            marginBottom: '8px',
          }}>{show.title}</h2>
          <p style={{
            fontSize: '0.75rem',
            letterSpacing: '0.1em',
            color: 'var(--mid-gray)',
            textTransform: 'uppercase',
          }}>{show.venue}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem',
            color: 'var(--black)',
            fontWeight: 300,
          }}>{show.price}</p>
          <p style={{ fontSize: '0.7rem', color: 'var(--mid-gray)', letterSpacing: '0.08em' }}>
            Μειωμένο: {show.reducedPrice}
          </p>
        </div>
      </div>

      <p style={{
        fontSize: '0.6rem',
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '20px',
      }}>Επιλέξτε Ημερομηνία</p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '32px' }}>
        {show.dates.map((d, i) => (
          <button
            key={i}
            disabled={!d.available}
            onClick={() => setSelected(i)}
            style={{
              padding: '12px 20px',
              border: `1px solid ${!d.available ? 'var(--light-gray)' : selected === i ? 'var(--black)' : 'var(--light-gray)'}`,
              background: selected === i ? 'var(--black)' : 'transparent',
              color: !d.available ? 'var(--mid-gray)' : selected === i ? 'white' : 'var(--dark-gray)',
              cursor: d.available ? 'pointer' : 'not-allowed',
              fontFamily: 'var(--font-body)',
              transition: 'all 0.2s',
              textDecoration: !d.available ? 'line-through' : 'none',
            }}
          >
            <span style={{ display: 'block', fontSize: '0.72rem', letterSpacing: '0.08em', marginBottom: '2px' }}>
              {d.date}
            </span>
            <span style={{ display: 'block', fontSize: '0.62rem', letterSpacing: '0.1em', color: selected === i ? 'var(--accent)' : 'var(--mid-gray)' }}>
              {d.time} {!d.available && '· Εξαντλήθηκε'}
            </span>
          </button>
        ))}
      </div>

      <button
        disabled={selected === null}
        style={{
          padding: '14px 40px',
          background: selected !== null ? 'var(--black)' : 'var(--light-gray)',
          color: selected !== null ? 'white' : 'var(--mid-gray)',
          border: 'none',
          fontFamily: 'var(--font-body)',
          fontSize: '0.65rem',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          cursor: selected !== null ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s',
        }}
      >
        Αγορά Εισιτηρίου
      </button>
    </div>
  );
}

function PageHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: '72px' }}>
      <p style={{
        fontSize: '0.62rem',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '12px',
      }}>{subtitle}</p>
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        fontWeight: 300,
        letterSpacing: '0.04em',
        color: 'var(--black)',
        lineHeight: 1,
      }}>{title}</h1>
      <div style={{ width: '40px', height: '1px', background: 'var(--accent)', marginTop: '20px' }} />
    </div>
  );
}
